import { useEffect, useMemo, useState } from 'react'
import { useAtomValue, useSetAtom } from 'jotai'
import { useParams } from 'react-router-dom'
import { WorkspaceBreadcrumbs } from '../components/workspace-breadcrumbs'
import { LoadingSpinner } from '@app/components/ui/LoadingSpinner/LoadingSpinner'
import { WorkspacesCreateEditSteps } from '../components/workspaces-create-edit-steps'
import { WorkspaceStepSelector } from '../components/workspace-step-selector'
import { CREATE_EDIT_WORKSPACE_STEPS } from '../workspace.constants'
import { riskAvailableWorkspacesAtom } from '@app/state/riskAtoms'
import { Step } from '../../shared/types/riskWorkspace.types'
import { riskWorkspaceAtom } from '../../shared/state/riskWorkspace.atom'

export const CreateEditWorkspace = () => {
  const [currentStep, setCurrentStep] = useState<Step>('overview')
  const { workspaceId } = useParams()

  const {
    data: workspaces,
    isPending,
    isLoading,
    isError,
  } = useAtomValue(riskAvailableWorkspacesAtom)

  const setWorkspaceForm = useSetAtom(riskWorkspaceAtom)

  useEffect(() => {
    if (!workspaceId || !workspaces) return

    const workspace = workspaces.find((workspace) => workspace.id === workspaceId)
    if (!workspace) return

    setWorkspaceForm((prev) => ({
      ...prev,
      name: workspace.name,
      description: workspace.description,
      access: workspace.visibility,
    }))
  }, [workspaceId, workspaces, setWorkspaceForm])

  if (!workspaces || isPending || isLoading) {
    return <LoadingSpinner />
  }

  if (isError) {
    return <p>Something went wrong...</p>
  }

  const onSelectNextStep = () => {
    const keys = Object.keys(CREATE_EDIT_WORKSPACE_STEPS)
    const currentIndex = keys.indexOf(currentStep)
    const nextKey = keys[currentIndex + 1] as Step
    setCurrentStep(nextKey)
  }

  const onSelectPrevStep = () => {
    const keys = Object.keys(CREATE_EDIT_WORKSPACE_STEPS)
    const currentIndex = keys.indexOf(currentStep)
    const prevKey = keys[currentIndex - 1] as Step
    setCurrentStep(prevKey)
  }

  return (
    <div>
      {/* Breadcrumbs */}
      <WorkspaceBreadcrumbs />
      {/* Main content */}
      <div className="flex">
        <WorkspacesCreateEditSteps currentStep={currentStep} setCurrentStep={setCurrentStep} />
        <WorkspaceStepSelector
          currentStep={currentStep}
          nextStep={onSelectNextStep}
          prevStep={onSelectPrevStep}
        />
      </div>
    </div>
  )
}
